import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractInvertedBooleanEditControlComponent} from "../abstract-inverted-boolean-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InvertedSwitchEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-inverted-switch-edit-control",
    templateUrl: "inverted-switch-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class InvertedSwitchEditControlComponent extends AbstractInvertedBooleanEditControlComponent {
    @Input() negative: string;
    @Input() positive: string;

    constructor(injector: Injector) {
        super(injector);
    }
}
